import React from 'react';
import { Column } from '../../../../model/table';
import { ApplicationField, LogsDto, ThreatNameField, TimestampField } from '../../../../dtos/logs.dto';
import { TooltipCell } from './special-cells';
import { Severity } from './sevirity/sevirity';

export const threatColumns: Column<LogsDto>[] = [
    {
        accessor: TimestampField,
        header: TimestampField,
        width: 220,
    },
    {
        accessor: 'Threat Type',
        header: 'Threat Type',
        width: 200,
    },
    {
        accessor: ThreatNameField,
        header: ThreatNameField,
        width: 220,
        getDisplayElement: TooltipCell
    },
    {
        accessor: 'Destination IP',
        header: 'Destination IP',
        width: 350,
    },
    {
        accessor: 'Destination Country',
        header: 'Destination Country',
        width: 200,
    },
    {
        accessor: 'To Port',
        header: 'Port',
        width: 150,
    },
    {
        accessor: ApplicationField,
        header: ApplicationField,
        width: 200,
    },
    {
        accessor: 'Child App',
        header: 'Child App',
        width: 200,
    },
    {
        accessor: 'Severity',
        header: 'Severity',
        width: 150,
        getDisplayElement: (column, row) => <Severity severityId={row?.Severity} />
    },
    {
        accessor: 'Action',
        header: 'Action',
        width: 150,
    },
];
